export default {

    // PAYOUTS

    ADMIN_ADD_APPLICATION_PAYOUT_INFO: {
        url: "/api/v1/application/payout",
        method: "post"
    },

    EXPORT_APPLICATION_PAYOUT: {
        url: "/api/v1/application/payout/export",
        method: "get"
    },

    GET_APPLICATION_PAYOUT_INFO: {
        url: "/api/v1/application/payout",
        method: "get"
    },

    GET_CONNECTOR_PAYOUT_METRICS_INFO: {
        url: "/api/v1/application/payout/payment-info",
        method: "get"
    },

    GET_PAYOUT_STATUS_BREAKDOWN: {
        url: "/api/v1/application/payout/payout-status-breakdown",
        method: "get"
    },

    ADMIN_UPDATE_APPLICATION_PAYOUT_INFO: {
        url: "/api/v1/application/payout/{application_id}",
        method: "put"
    },

    GET_CONNECTOR_SUMMARY_STATUS: {
        url: "/api/v1/application/payout/connector-summary",
        method: "get"
    },
    ADD_PAYOUT_RATE: {
        url: "/api/v1/payout-rate",
        method: "post",
    },
    ADD_PAYOUT_RATE_TO_MONTH: {
        url: "/api/v1/payout-rate/rates/{payoutMonthId}",
        method: "post",
    },
    GET_ALL_PAYOUTS: {
        url: "/api/v1/payout-rate",
        method: "get",
    },
    GET_PAYOUT_RATE_BY_ID: {
        url: "/api/v1/payout-rate/month/{payoutMonthId}",
        method: "get",
    },
    GET_PREVIOUS_YEAR_PAYOUTS: {
        url: "/api/v1/payout-rate/copy/previous-year",
        method: "get",
    },
    GENERATE_PAYOUT_PDF: {
        url: "/api/v1/payout-rate/generate-pdf",
        method: "get",
    },
}